import React from 'react';
import clsx from 'clsx';

interface OpportunityPhaseLayoutProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  toolbar?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const OpportunityPhaseLayout: React.FC<OpportunityPhaseLayoutProps> = ({
                                                                         title,
                                                                         subtitle,
                                                                         actions,
                                                                         toolbar,
                                                                         children,
                                                                         className,
                                                                       }) => {
  return (
    <div className={clsx('w-full max-w-7xl mx-auto px-4 md:px-6 py-4', className)}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
          <div>
            <h2 className="text-2xl font-semibold m-0">{title}</h2>
            {subtitle && <p className="text-sm text-gray-600 mt-1 mb-0">{subtitle}</p>}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>

        {toolbar && (
          <div className="rounded-lg border border-gray-200 bg-white p-4">
            {toolbar}
          </div>
        )}

        <div className="min-h-0">{children}</div>
      </div>
    </div>
  );
};

export default OpportunityPhaseLayout;